import { Element } from '@thive/canvas';
import { Areas, Group, LogicalSpace, Obstacle } from '@thive/fddm-types';

import { computeRectanglesBoundingBoxExtent } from '@/modules/common/helpers/boundingBox';

import { filterAreasByIds } from '@/modules/floorplanDesign/helpers';
import { FDDM_TAG, INTERACTIVITY_OFF } from '@/modules/floorplanDesign/constants';
import { getGroupBorderId } from '@/modules/floorplanDesign/mappers/helpers/helpers';
import { RectangleUtils } from '@/modules/floorplanDesign/helpers/RectangleUtils';

import { elementFactory } from '../factories';
import { createPaddedBoundingBoxRectangle } from './mapperHelpers';

export const groupMapper = (
  groups: Group[],
  allAreas: Areas,
  logicalSpaces: LogicalSpace[],
  obstacles: Obstacle[],
): Element[] =>
  groups.flatMap((group) => {
    const groupItemIds = new Set(group.areaIds);

    const areaRectangles = RectangleUtils.convertAreasToRectangles(
      filterAreasByIds(allAreas, groupItemIds),
    );
    const logicalSpaceRectangles = RectangleUtils.convertLogicalSpacesToRectangles(
      logicalSpaces.filter((logicalSpace) => groupItemIds.has(logicalSpace.id)),
    );
    const obstacleRectangles = RectangleUtils.convertObstaclesToRectangles(
      obstacles.filter((obstacle) => groupItemIds.has(obstacle.id)),
    );

    const rectangles = [...areaRectangles, ...logicalSpaceRectangles, ...obstacleRectangles];

    if (rectangles.length === 0) return [];

    const boundingBox = computeRectanglesBoundingBoxExtent(rectangles);

    return [
      elementFactory.buildGroupLogicalElement({
        id: group.id,
        name: group.name,
        interactivity: {
          selectable: true,
          draggable: true,
          rotatable: true,
          editable: false,
        },
        tags: [FDDM_TAG.GROUP],
      }),
      elementFactory.buildRectangleElement({
        id: getGroupBorderId(group.id),
        z: 0,
        interactivity: INTERACTIVITY_OFF,
        rectangle: createPaddedBoundingBoxRectangle(boundingBox, 0.2),
        color: '#00000000',
        stroke: {
          color: '#22222244',
          width: 50,
        },
        parentId: group.id,
        tags: [FDDM_TAG.GROUP],
      }),
    ];
  });
